<template>
  <div :key="$route.path" style="background: #141416">
    <li style="background: #141416; list-style-type: none; height: 10px"></li>
    <ul class="list-group MobileHide pr-0 pl-0">
      <!-- <li class="list-group-item header LeagueName MobileHide">{{lName}}</li> -->
      <li
        class="list-group-item"
        style="color: white; background: #212225"
        v-if="!leagueTable.standings[0].groupName"
      >
        <div class="row">
          <div class="col">#</div>
          <div class="col-6">
            {{ $t("LanguageEn.txtTeam") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTableCount") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTableWin") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTableDraw") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTableLose") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTableGoals") }}
          </div>
          <div class="col">
            {{ $t("LanguageEn.txtTablePoint") }}
          </div>
        </div>
      </li>
      <div v-for="table in standings1" :key="table.idll">
        <div v-for="(group, i) in table" :key="group.id">
          <li
            class="list-group-item header"
            style="
              background: #2c2d31;
              margin-top: 0px;
              margin-bottom: 0px;
              color: white;
              text-align: center;
              line-height: 5px;
            "
            v-if="i < 1 && group.groupName"
          >
            <div class="row">
              <div class="col">#</div>
              <div class="col-6" style="text-align: left">
                {{ group.groupName | transliterate(cookiesObject.lang) }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTableCount") }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTableWin") }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTableDraw") }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTableLose") }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTableGoals") }}
              </div>
              <div class="col">
                {{ $t("LanguageEn.txtTablePoint") }}
              </div>
            </div>
          </li>
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-6"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  {{ group.team.name | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <div v-for="table in standings" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-6"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  {{ group.team.name | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <li style="background: #141416; list-style-type: none; height: 10px"></li>
      <li
        class="list-group-item header"
        style="
          background: #2c2d31;
          margin-top: 0px;
          margin-bottom: 0px;
          color: white;
          line-height: 5px;
        "
        v-if="rr.length > 0"
      >
        <div class="row">
          <div class="col">
            {{ "Relegation Round" | transliterate(cookiesObject.lang) }}
          </div>
        </div>
      </li>
      <div v-for="table in standings2" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-6"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  {{ group.team.name | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <li style="background: #141416; list-style-type: none; height: 10px"></li>
      <li
        class="list-group-item header"
        style="
          background: #2c2d31;
          margin-top: 0px;
          margin-bottom: 0px;
          color: white;
          line-height: 5px;
        "
        v-if="rr.length > 0"
      >
        <div class="row">
          <div class="col">
            {{ "Championship Round" | transliterate(cookiesObject.lang) }}
          </div>
        </div>
      </li>
      <div v-for="table in standings3" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-6"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  {{ group.team.name | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>
    </ul>

    <ul class="list-group MobileShow pr-0 pl-0">
      <!-- <li class="list-group-item header LeagueName MobileHide">{{lName}}</li> -->
      <li
        class="list-group-item"
        style="color: white; background: #212225"
        v-if="!leagueTable.standings[0].groupName"
      >
        <div class="row">
          <div class="col">#</div>
          <div class="col-4">
            {{ $t("LanguageEn.txtTeam") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTableCount") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTableWin") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTableDraw") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTableLose") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTableGoals") }}
          </div>
          <div class="col pr-2 pl-2">
            {{ $t("LanguageEn.txtTablePoint") }}
          </div>
        </div>
      </li>
      <div v-for="table in standings1" :key="table.idll">
        <div v-for="(group, i) in table" :key="group.id">
          <li
            class="list-group-item header"
            style="
              background: #2c2d31;
              margin-top: 0px;
              margin-bottom: 0px;
              color: white;
              text-align: center;
              line-height: 5px;
            "
            v-if="i < 1 && group.groupName"
          >
            <div class="row">
              <div class="col">#</div>
              <div class="col-4" style="text-align: left">
                {{ group.groupName | transliterate(cookiesObject.lang) }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTableCount") }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTableWin") }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTableDraw") }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTableLose") }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTableGoals") }}
              </div>
              <div class="col pr-2 pl-2">
                {{ $t("LanguageEn.txtTablePoint") }}
              </div>
            </div>
          </li>
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-4"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  <span v-if="group.team.shortCode">{{
                    group.team.shortCode | transliterate(cookiesObject.lang)
                  }}</span
                  ><span v-else>{{
                    group.team.name.slice(0, 3).toUpperCase()
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <div v-for="table in standings" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-4"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  <span v-if="group.team.shortCode">{{
                    group.team.shortCode | transliterate(cookiesObject.lang)
                  }}</span
                  ><span v-else>{{
                    group.team.name.slice(0, 3).toUpperCase()
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <li style="background: #141416; list-style-type: none; height: 10px"></li>
      <li
        class="list-group-item header"
        style="
          background: #2c2d31;
          margin-top: 0px;
          margin-bottom: 0px;
          color: white;
          line-height: 5px;
        "
        v-if="rr.length > 0"
      >
        <div class="row">
          <div class="col">
            {{ "Relegation Round" | transliterate(cookiesObject.lang) }}
          </div>
        </div>
      </li>
      <div v-for="table in standings2" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-4 pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  <span v-if="group.team.shortCode">{{
                    group.team.shortCode | transliterate(cookiesObject.lang)
                  }}</span
                  ><span v-else>{{
                    group.team.name.slice(0, 3).toUpperCase()
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{ group.goalScored - group.goalAgainst }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>

      <li style="background: #141416; list-style-type: none; height: 10px"></li>
      <li
        class="list-group-item header"
        style="
          background: #2c2d31;
          margin-top: 0px;
          margin-bottom: 0px;
          color: white;
          line-height: 5px;
        "
        v-if="rr.length > 0"
      >
        <div class="row">
          <div class="col">
            {{ "Championship Round" | transliterate(cookiesObject.lang) }}
          </div>
        </div>
      </li>
      <div v-for="table in standings3" :key="table.idll">
        <div v-for="group in table" :key="group.id">
          <li
            style="
              height: 35px;
              border: none;
              font-size: 14px;
              background: #141416;
            "
            class="list-group-item"
          >
            <router-link
              style="text-decoration: none"
              id="router-link"
              :to="{ name: 'teamPagePar', params: { id: group.team.id } }"
              ><div class="row">
                <div
                  class="col"
                  style="
                    color: white;
                    background: #3c3e43;
                    height: 35px;
                    margin-top: -12px;
                    text-align: center;
                    border-bottom: 1px solid black;
                  "
                >
                  <p style="margin-top: 11px">
                    {{ group.position | transliterate(cookiesObject.lang) }}
                  </p>
                </div>
                <div
                  class="col-4"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  <img
                    :src="teamLogo + group.team.id"
                    alt=""
                    style="width: 17px; margin-right: 5px; margin-bottom: 3px"
                  />
                  <span v-if="group.team.shortCode">{{
                    group.team.shortCode | transliterate(cookiesObject.lang)
                  }}</span
                  ><span v-else>{{
                    group.team.name.slice(0, 3).toUpperCase()
                      | transliterate(cookiesObject.lang)
                  }}</span>
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.gameCount | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.win | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.draw | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.lose | transliterate(cookiesObject.lang) }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="
                    color: white;
                    text-align: center;
                    border-bottom: 1px solid #2c2d31;
                  "
                >
                  {{
                    (group.goalScored - group.goalAgainst)
                      | transliterate(cookiesObject.lang)
                  }}
                </div>
                <div
                  class="col pr-2 pl-2"
                  style="color: white; border-bottom: 1px solid #2c2d31"
                >
                  {{ group.points | transliterate(cookiesObject.lang) }}
                </div>
              </div></router-link
            >
          </li>
        </div>
      </div>
    </ul>
  </div>
</template>
<!-- <img :src="teamLogo + group.team.id" alt="" style="width: 17px; margin-right: 5px; margin-bottom: 3px;" > <span v-if="group.team.shortCode">{{group.team.shortCode}}</span><span v-else>{{group.team.name.slice(0,3).toUpperCase()}}</span> -->

<script>
import { mapGetters } from "vuex";

export default {
  name: "LeaguePage",
  data() {
    return {
      leagueTable: [],
      id: "",
      cookiesObject: "",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      standings: [],
      standings1: [],
      standings2: [],
      standings3: [],
      lName: "",
      rs: "",
      gs: "",
      rr: "",
      cr: "",
      test: "",
    };
  },
  async created() {
    this.id = this.$route.params.leagueId;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    const res = await fetch(
      this.httpReq +
        "/standings?portalId=" +
        (cookiesObject.portalId ? cookiesObject.portalId : 0) +
        "&token=" +
        cookiesObject.token +
        "&tournamentId=" +
        this.id
    );
    const data = await res.json();
    const leagueTable = data;
    this.leagueTable = leagueTable;
    this.lName = data.standings[0].tournament.name;

    // filter data here first ---------------------------->
    this.rs = this.leagueTable.standings.filter(
      (gr) => gr.stage.name == "Regular Season"
    );
    this.gs = this.leagueTable.standings.filter(
      (gr) => gr.stage.name == "Group Stage"
    );
    this.rr = this.leagueTable.standings.filter(
      (gr) => gr.stage.name == "Relegation Round"
    );
    this.cr = this.leagueTable.standings.filter(
      (gr) => gr.stage.name == "Championship Round"
    );

    this.standings = this.groupBy(this.rs, "groupName");
    this.standings1 = this.groupBy(this.gs, "groupName");
    this.standings2 = this.groupBy(this.rr, "groupName");
    this.standings3 = this.groupBy(this.cr, "groupName");
  },
  components: {},
  props: {},
  methods: {
    groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        // Add object to list for given key's value
        acc[key].push(obj);
        return acc;
      }, {});
    },
  },
  computed: {
    ...mapGetters(["httpReq"]),
  },
};
</script>

<style scoped>
.list-group-item {
  line-height: 6px;
  border-radius: 0px;
  border: none;
  font-size: 13px;
}
.LeagueName {
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
  font-size: 14px;
}

.header {
  background: #242424;
  color: white;
}
#router-link,
#router-link:visited,
#router-link:active,
#router-link:focus {
  text-decoration: none;
  border: 0;
  outline: 0;
  color: #242424;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
